import React from 'react'
import image1 from "../../img/profiles/avatar-16.jpg"
import image2 from "../../img/icons/emoji-01.svg"
import { useSelector } from 'react-redux';
import { useGetSingleAdminDataQuery } from '../../../redux-toolkit/services/AdminApi/AdminApi';

const StartMessagePage = () => {

    const { AuthInfo } = useSelector((state) => state?.auth);
    const { data, error, isLoading } = useGetSingleAdminDataQuery(AuthInfo?.email);

    if (isLoading) {
        return;
    }
    return (
        <> 
            {/* <!-- StartMessagePage --> */}
            <div className="welcome-content d-flex align-items-center justify-content-center">
                <div className="welcome-info text-center">
                    <div className="welcome-box bg-white d-inline-flex align-items-center">
                        <span className="avatar avatar-md me-2">
                            <img
                                src={
                                    data?.data?.picture
                                        ? `${process.env.REACT_APP_Authorized_API_URL}/${data.data.picture}`
                                        : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s"
                                }
                                onError={(e) => (e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqf0Wx4wmsKfLYsiLdBx6H4D8bwQBurWhx5g&s")}
                                alt="profile"
                                className="rounded-circle"
                            />
                        </span>
                        <h6>Welcome! {data?.data?.name}</h6>
                    </div>
                    <p>Choose a person  to start Start Message with them.</p>
                </div>
            </div>
            {/* <!-- /StartMessagePage --> */}
        </>
        )
}

export default StartMessagePage